import { Route } from '@angular/router'

import { ApplicationResourcesRoutes } from './application-resources-routes'
import { ApplicationRuntimeRoutes } from './application-runtime-routes'

export const ApplicationMainLayoutRoutes: Route[] = [
  {
    path: 'config/:appVersionId',
    data: { routeKey: 'config' },
    children: ApplicationResourcesRoutes,
  },
  {
    path: 'runtime',
    loadComponent: () =>
      import('./components/runtime-main-layout/runtime-main-layout.component').then(
        ({ RuntimeMainLayoutComponent }) => RuntimeMainLayoutComponent
      ),
    children: ApplicationRuntimeRoutes,
  },
]
